// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"checkbox_Checkbox__39COh"};